import { Control, FieldErrors, useFieldArray, UseFormRegister } from 'react-hook-form';
import { Stack } from '@mui/material';

import { TextFieldWithHelperSpace } from '@components/TextFieldWithHelperSpace';

import { predefinedPromptsByRoleTexts } from '../../../constants';
import { FormValues } from '../PredefinedPromptsByRole';

import { AddButton } from './AddButton';
import { PromptSectionTitle } from './PromptSectionTitle';

interface PromptSectionProps {
    errors: FieldErrors<FormValues>;
    roleIndex: number;
    register: UseFormRegister<FormValues>;
    isSending: boolean;
    roleId: string;
    control: Control<FormValues>;
}

export const PromptSection = ({
    errors,
    roleIndex,
    register,
    isSending,
    roleId,
    control,
}: PromptSectionProps) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `roles.${roleIndex}.prompts`,
    });

    return (
        <Stack gap={2}>
            {fields.map(({ promptId, id: fieldId }, promptIndex) => {
                const labelError = errors.roles?.[roleIndex]?.prompts?.[promptIndex]?.label;
                const textError = errors.roles?.[roleIndex]?.prompts?.[promptIndex]?.text;

                return (
                    <Stack key={fieldId} gap={1}>
                        <PromptSectionTitle
                            promptId={promptId}
                            roleId={roleId}
                            promptIndex={promptIndex}
                            deleteDynamicField={remove}
                        />
                        <TextFieldWithHelperSpace
                            label={predefinedPromptsByRoleTexts.labelInputTitle}
                            disabled={isSending}
                            {...register(`roles.${roleIndex}.prompts.${promptIndex}.label`)}
                            fieldError={labelError}
                            size='small'
                        />
                        <TextFieldWithHelperSpace
                            label={predefinedPromptsByRoleTexts.textInputTitle}
                            disabled={isSending}
                            multiline
                            minRows={2}
                            {...register(`roles.${roleIndex}.prompts.${promptIndex}.text`)}
                            fieldError={textError}
                        />
                    </Stack>
                );
            })}
            <AddButton onAdd={() => append({ label: '', text: '' })} />
        </Stack>
    );
};
